module.exports = __webpack_public_path__ + "img/secondfeature.225151bf.svg";